import React from 'react';
import PNewsArticles from './pages/PNewsArticles';

type NewsProps = {
	page: string;
};
const News = (props: NewsProps) => {
	const { page } = props;

	switch (page) {
		default:
		case 'articles':
			return <PNewsArticles />;
	}
};

export default News;
